import { useQuery, UseQueryResult } from 'react-query';
import { Dayjs } from 'dayjs';
import { CORE_API_SUFFIX, dataFetch } from '../../../axios/customAxios';
import { appendQueryParamIfNotEmpty, formatDate, generateQueryKey } from '../../../constants/hookConstants';
import { ApiError, ApiResponse } from '../../../interfaces/apiResponse.type';
import { SoldProductReportRow } from '../../../interfaces/soldProductReport.interface';

interface TopProductsFromAdsReport {
  hasNextPage: boolean;
  report: SoldProductReportRow[];
}

export const useGetTopProductsFromAds = (
  identifier: string,
  from: Dayjs | null,
  to: Dayjs | null,
  page: number,
): UseQueryResult<ApiResponse<TopProductsFromAdsReport>, ApiError<TopProductsFromAdsReport>> => {
  const queryParams = new URLSearchParams();
  appendQueryParamIfNotEmpty(queryParams, 'page', page.toString());
  appendQueryParamIfNotEmpty(queryParams, 'from', formatDate(from));
  appendQueryParamIfNotEmpty(queryParams, 'to', formatDate(to));

  const queryKey = generateQueryKey(identifier, queryParams);

  return useQuery(
    [`reports_${queryKey}`],
    () => dataFetch.get(`${CORE_API_SUFFIX}sold-products/top-products-from-ads?${queryParams}`),
  );
};
